import React, {Component} from 'react'
import propTypes from 'prop-types'
import iconNames from 'theme/icons'
import Button from 'components/button'
import {prefix} from 'helpers/component'

const getClassName = prefix('pivotTable-gutter-')

class Gutter extends Component {

  render() {
    const {
      hasSubData,
      expanded,
      highlighted,
      showLine,
      showTop,
      showBottom,
      shopTopPlate,
      showEndPlate,
      onToggle,
    } = this.props

    const classes = ['container']
    if (hasSubData) classes.push('sub')
    if (expanded) classes.push('expanded')
    if (highlighted) classes.push('highlighted')
    if (!showTop) classes.push('noTop')
    if (!showBottom) classes.push('noBottom')

    const line = showLine ? <div className={getClassName('line')}/> : null
    const button = hasSubData
      ? (
        <Button
          onClick={onToggle}
          flat
          icon={expanded ? iconNames.pivotTableGutterExpanded : iconNames.pivotTableGutterContracted}
        />
      )
      : null
    const topPlate = shopTopPlate ? <div className={getClassName('topPlate')}/> : null
    const endPlate = showEndPlate ? <div className={getClassName('endPlate')}/> : null

    return (
      <div className={getClassName(classes)}>
        {line}
        {topPlate}
        {button}
        {endPlate}
      </div>
    )
  }
}

Gutter.propTypes = {
  hasSubData: propTypes.bool.isRequired,
  expanded: propTypes.bool,
  highlighted: propTypes.bool,
  showLine: propTypes.bool,
  showTop: propTypes.bool,
  showBottom: propTypes.bool,
  shopTopPlate: propTypes.bool,
  showEndPlate: propTypes.bool,
  onToggle: propTypes.func,
}

Gutter.defaultProps = {
  showLine: true,
  showTop: true,
  showBottom: true,
}

export default Gutter
